import i18n from '@/langs/i18n.js';

export default [
  {
    text: i18n.t('statuses.toAccept'),
    value: 'TO_ACCEPT',
    badgeTheme: 'waiting-for-offer'
  },
  {
    text: i18n.t('statuses.accepted'),
    value: 'ACCEPTED',
    badgeTheme: 'sent'
  },
  {
    text: i18n.t('statuses.rejected'),
    value: 'REJECTED',
    badgeTheme: 'cancelled'
  }
]
